import { render, staticRenderFns } from "./SealSoftware.vue?vue&type=template&id=63a33af8&scoped=true"
import script from "./SealSoftware.vue?vue&type=script&lang=js"
export * from "./SealSoftware.vue?vue&type=script&lang=js"
import style0 from "./SealSoftware.vue?vue&type=style&index=0&id=63a33af8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a33af8",
  null
  
)

export default component.exports